export default "__VITE_ASSET__DLEMTZeB__"